import React from 'react'

import {
    Table,
    Card,
    Input,
    Button,
    message,
    Row,
    Col,
    Icon,
    Switch
} from 'antd'

import {
    _postEditDocCategory,
    _postEditDocSubCategory,
    _postToggleDocCategoryActive,
    _postToggleDocSubCategoryActive
} from '../../services'

import AddCategory from './add-category'

class DocCategoryTable extends React.Component{

    state = {
        activeId: false,
        activeKey: false,
        activeInput: false,

        subActiveId: false,
        subActiveKey: false,
        subActiveInput: false
    }
    
    render(){
        
        const { docCategories, loading } = this.props

        const { 
            activeId, 
            activeKey,
            subActiveId,
            subActiveKey
        } = this.state
        
        return(
            <Table
                loading={loading}
                columns={[{
                    title: 'Title',
                    dataIndex: 'title',
                    render: (title, record) => {

                        const key = 'title'

                        return this.renderInput(record, key, title)
                    }
                },{
                    title: 'Actions',
                    render: (record) => (
                        <Row type="flex" gutter={12} align='middle'>
                            <Col>
                                <AddCategory
                                    buttonText="Add Sub Category"
                                    handleSubmit={(subTitle)=>this.props.handleAddSubCategory(record._id, subTitle)}
                                />
                            </Col>
                            <Col>
                                Active <Switch 
                                defaultChecked={record.active}
                                onChange={()=>this.handleToggleActive(record._id)}/>
                            </Col>
                            <Col>
                                <Button
                                    onClick={()=>this.handleRemove(record._id)}
                                    size="small"
                                    type="danger"
                                >
                                    Remove
                                </Button>
                            </Col>
                        </Row>
                    )
                }]}
                dataSource={docCategories}
                expandedRowRender={(record)=> {
                    return (
                        <Card
                            bordered={false}
                        >
                            <Table
                                pagination={false}
                                dataSource={record.subCategories}
                                columns={[{
                                    title: 'Title',
                                    dataIndex: 'title',
                                    render: (title, subRecord) => {

                                        const key = 'title'
                
                                        return this.renderInputSub(subRecord, key, title)
                                    }
                                },{
                                    title: 'Description',
                                    dataIndex: 'description',
                                    render: (description, subRecord) => {

                                        const key = 'description'
                
                                        return this.renderInputSub(subRecord, key, description, true)
                                    }
                                },{
                                    title: 'Actions',
                                    render:(subRecord) => {
                                        return(
                                            <Row type="flex" gutter={12} align='middle'>
                                                <Col>
                                                    Active <Switch 
                                                    defaultChecked={subRecord.active}
                                                    onChange={()=>this.handleToggleActiveSub(subRecord._id)}/>
                                                </Col>
                                                <Col>
                                                    <Button
                                                        onClick={()=>this.handleRemoveSub(record._id, subRecord._id)}
                                                        type="danger"
                                                    >
                                                        Remove
                                                    </Button>
                                                </Col>
                                            </Row>
                                        )
                                    }
                                }]}
                            />
                        </Card>
                    )
                }}
            />
        )
    }

    renderInput = (record, key, defaultValue) => {

        const { activeId, activeKey } = this.state

        const disabled = activeId != record._id || activeKey != key

        return(
            <div>
                <Input
                    style={{width: 400}}
                    // onPressEnter={this.handleEdit}
                    onChange={(e) => this.setState({
                        activeInput: e.target.value
                    })}
                    onFocus={(e)=>this.setState({
                        activeId: record._id,
                        activeKey: key,
                        activeInput: e.target.value
                    })}
                    readOnly={disabled}
                    defaultValue={defaultValue}
                />
                <Button 
                type="primary"
                disabled={disabled}
                style={{ marginLeft: 4}}
                shape="circle"
                onClick={this.handleEdit}
                icon="save"/>
            </div>
        )
    }

    renderInputSub = (record, key, defaultValue, textArea = false ) => {

        const { subActiveId, subActiveKey } = this.state

        const disabled = subActiveId != record._id || subActiveKey != key

        return (
            <div>
                {textArea?
                <Input.TextArea
                    rows={4}
                    style={{width: 400}}
                    // onPressEnter={this.handleEditSub}
                    onChange={(e) => this.setState({
                        subActiveInput: e.target.value
                    })}
                    onFocus={(e)=>this.setState({
                        subActiveId: record._id,
                        subActiveKey: key,
                        subActiveInput: e.target.value
                    })}
                    readOnly={disabled}
                    defaultValue={defaultValue}
                />
                :
                <Input
                    style={{width: 400}}
                    // onPressEnter={this.handleEditSub}
                    onChange={(e) => this.setState({
                        subActiveInput: e.target.value
                    })}
                    onFocus={(e)=>this.setState({
                        subActiveId: record._id,
                        subActiveKey: key,
                        subActiveInput: e.target.value
                    })}
                    readOnly={disabled}
                    defaultValue={defaultValue}
                />}
                <Button 
                    disabled={disabled}
                    type="primary"
                    style={{ marginLeft: 4}}
                    shape="circle"
                    onClick={this.handleEditSub}
                    icon="save"/>
            </div>
        )
    }

    handleRemoveSub = (docCategoryId, docSubCategoryId) => {
        this.props.removeDocSubCategory(docCategoryId, docSubCategoryId)
    }

    handleRemove = (docCategoryId) => {
        this.props.removeDocCategory(docCategoryId)
    }

    handleToggleActive = (docCategoryId) => {
        _postToggleDocCategoryActive(docCategoryId)
        .then( res => {
            message.success("Toggle Active Success")
        })
    }

    handleToggleActiveSub = (docSubCategoryId) => {
        _postToggleDocSubCategoryActive(docSubCategoryId)
        .then( res => {
            message.success("Toggle Active Success")
        })
    }

    handleEditSub = () => {

        const { subActiveKey, subActiveId, subActiveInput } = this.state

        _postEditDocSubCategory({
            editKey: subActiveKey,
            docSubCategoryId: subActiveId,
            value: subActiveInput
        })
        .then( res => {
            this.setState({
                subActiveId: false,
                subActiveInput: false,
                subActiveKey: false
            })
            message.success("Edit success")
        })

    }

    handleEdit = () => {

        const { activeKey, activeId, activeInput } = this.state

        _postEditDocCategory({
            editKey: activeKey,
            docCategoryId: activeId,
            value: activeInput
        })
        .then( res => {
            this.setState({
                activeKey: false,
                activeId: false,
                activeInput: false
            })
            message.success("Edit success")
        })

    }
}

export default DocCategoryTable


// WEBPACK FOOTER //
// ./src/components/docs/category-table.js